// extracted by mini-css-extract-plugin
export default {"container":"CancelPage_container__2en0M","message":"CancelPage_message__Fphg9"};